Mmg.addShortcode(
  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'mortgage_rate_table',
  '.sc-mortgage-rate-table',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector) => {

    const $this = $(el);
    const $iframe = $this.find(`${selector}__iframe`).first();

    /**
     * Initialize the widget
     */
    (function init() {
      addEvents();
    })();

    /**
     * Handle UI events
     */
    function addEvents() {
      $iframe.on('load', onLoad);

      // Race condition guard: iframe content loaded before addEvents fires
      if ($iframe.prop('contentDocument')?.readyState === 'complete') {
        onLoad();
      }
    }

    /**
     * Sync iframe height on load, then watch for content resizes
     */
    function onLoad() {
      try {
        resetHeight();
        new ResizeObserver(resetHeight).observe(
          $iframe.prop('contentDocument').body
        );
      } catch (error) {
        $this.css('--iframe-height', '');
      }
    }

    /**
     * Set iframe height from body content. body.scrollHeight is viewport-independent,
     * so it stays accurate without clearing the iframe height first (avoids feedback loops).
     */
    function resetHeight() {
      $this.css('--iframe-height', $iframe.prop('contentDocument').body.scrollHeight + 'px');
    }
  }
);
